import React from 'react';
import { Link, Route, withRouter } from 'react-router-dom';
import useCheckIsMobile from 'Shared/hooks/useCheckIsMobile';
import { FormMode } from '../../../../../screens/Admin/constants/constants';
import pathToUrl from 'Shared/util/pathToUrl';

import EditLargeSVG from 'Components/Admin/assets/EditLargeSVG';
import PlusMediumSVG from 'Components/Admin/assets/PlusMediumSVG';

import AppSwitch from 'Components/AppSwitch';
import { SubForm } from 'Components/Admin/Form';
import withPagination from 'Components/Admin/Form/components/SubForm/withPagination';
import withSetAsCurrentField from 'Components/Admin/Form/components/SubForm/withSetAsCurrentField';

const PaginationSubForm = withSetAsCurrentField(withPagination(SubForm));
const SingleSubForm = withSetAsCurrentField(SubForm);

const SubFormContainer = ({ children, isSelected, name, pathName, match, isActionButtons, ...props }) => {
  const isMobile = useCheckIsMobile();

  const getUrl = (action) => pathToUrl(match.path, match.params) + (pathName || name) + '/' + action;
  const getPath = (action) => match.path + (pathName || name) + '/' + action + '/';

  const renderSubForm = (mode) => {
    const SubFormComponent = props.pages ? PaginationSubForm : SingleSubForm;

    return (routeProps) => (
      <SubFormComponent
        {...props}
        {...routeProps}
        name={name}
        closeUrl={pathToUrl(match.path, match.params)}
        mode={mode}
      />
    );
  };

  return (
    <>
      <div className="sub-form__field">
        {children}
        {
          !isMobile && isActionButtons && (
            <div className="sub-form__control">
              {isSelected && (
                <Link className="svg" to={getUrl('update/1')}>
                  <EditLargeSVG />
                </Link>
              )}
              <Link to={getUrl('create')} className="svg" data-testid={`${name}-add-btn`}>
                <PlusMediumSVG />
              </Link>
            </div>
          )
        }
      </div>
      <AppSwitch>
        <Route
          path={getPath('update/:entityId')}
          render={renderSubForm(FormMode.UPDATE)}
        />
        <Route
          path={getPath('create')}
          render={renderSubForm(FormMode.CREATE)}
        />
        <Route path={match.path} exact />
        <Route path={`${match.path}:entity/:action/:entityId?`} exact />
      </AppSwitch>
    </>
  );
};

export default withRouter(SubFormContainer);
